import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import {
  decimalPoint,
  convertToCurrency,
  getParents,
} from "../../../utils/helpers";
import {
  saveCreditCard,
  gotStripeToken,
  getStripeToken,
} from "../../../actions/booking";
import {
  updateCheckoutAppointmentStepData,
  getPosSettings,
  getGiftCertSetting,
  getInvoice,
  createInvoice,
  updateInvoice,
  updateDiscountDropdownVisibility,
  updatePaymentMode,
  changeTipPopupVisibility,
  changeUpdateInvoiceToBooking,
  updateBookingToInvoice,
  getBookingPayments,
  refundInvoicePayment,
  updateGettingStripeToken,
  updateShareInvoiceVisibility,
  sendShareInvoice,
  getInvoicePdf,
  updateGiftCertSaleFormVisibility,
  addNewGiftCertKeyToValueList,
  getGiftCertWithKey,
  getPaymentSetting,
} from "../../../actions/checkoutAppointmentStep";
import { saveBooking, updateBooking } from "../../../actions/booking";
import moment from "moment";
import { momentTimezone } from "../../../utils/momentTimezone";
import { getSpId } from "../../../utils/helpers";
import { ValidMe } from "../../shared/validMeReact";
import Txt from "../../shared/textInput";
import {
  confirmServicePriceChangeAndGenerateInvoice,
  createPayloadItemFromInvoiceItem,
  createInvoicePayload,
} from "../../shared/functions/confirmServicePriceChangeAndGenerateInvoice";

import {
  checkoutModesEnum,
  paymentModeEnum,
} from "../../../state/initialState";
import objectAssign from "object-assign";
import { Modal, Dimmer, Loader } from "semantic-ui-react";
import {
  updateGlobalErrorMessage,
  removeGlobalErrorMessageIfMatchesThisString,
} from "../../../actions/globalError";
import { updateAppointmentStepData } from "../../../actions/appointmentStep";
import { clone } from "../../../reducers/helper";
import { paymentStatusEnum } from "../../../state/initialState";
import CreditCardPaymentForm from "./components/creditCardPaymentForm";
import GiftCertPaymentForm from "./components/giftCertPaymentForm";
import GiftCertSaleForm from "./components/giftCertSaleForm";

import { StripeProvider, Elements } from "react-stripe-elements";
import SquareForm from "./components/SquareForm";

const timezoneMoment = momentTimezone(moment);
const maxPrice = 10000;

@connect(mapStateToProps)
export default class CenterPanelAppointmentCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      handleClickOutsideDiscountMenu: (e) => {
        if (
          !(e.target.className.indexOf("discount_select") > -1) &&
          getParents(e.target, ".discount_select").length == 0
        ) {
          //this means the click did not happen inside the dropdown
          this.updateDiscountDropdownVisibility(false);
        }
      },
    };
  }

  componentWillReceiveProps(props) {
    const {
      posSettings,
      currentBookingId,
      gettingInvoice,
      creatingInvoice,
      invoiceData,
      invoicePdfData,
      appointmentStepData,
    } = props;
    const { selectedCustomer } = this.props.appointmentStepData;
    const {
      selectedService,
    } = this.props.appointmentStepData.multiServiceList[0];
    let multiServiceItem = this.props.appointmentStepData.multiServiceList[0];
    const {
      invoiceKey,
      paymentAmount,
    } = this.props.checkoutAppointmentStepData;
    let { updatingInvoice } = this.props;
    const {
      updateInvoiceAfterPayment,
      haveDownloadDataAfterCashOrGiftPayment,
      printInvoicePdf,
      shouldUpdateInvoiceToBooking,
      bookingRevenue,
    } = props.checkoutAppointmentStepData;

    if (this.canCheckoutCurrentBooking()) {
      if (posSettings && currentBookingId && !invoiceData.key) {
        if (invoiceKey) {
          if (!gettingInvoice) {
            this.props.dispatch(getInvoice(invoiceKey));
          }
        } else {
          if (!creatingInvoice) {
            // create invoice
            const payload = createInvoicePayload(
              multiServiceItem,
              appointmentStepData,
              bookingRevenue,
              posSettings,
              currentBookingId,
              invoiceData
            );
            this.props.dispatch(createInvoice(payload));
            this.props.dispatch(changeUpdateInvoiceToBooking(false));
          }
        }
      } else if (
        posSettings &&
        invoiceData.key &&
        shouldUpdateInvoiceToBooking
      ) {
        let properBookingRevenue = Number(bookingRevenue);
        this.props.dispatch(changeUpdateInvoiceToBooking(false));
        if (
          invoiceData.balanceamount == 0 &&
          invoiceData.status != "PAID" &&
          !updatingInvoice
        ) {
          // update invoice
          const payload = createInvoicePayload(
            multiServiceItem,
            appointmentStepData,
            bookingRevenue,
            posSettings,
            currentBookingId,
            invoiceData
          );
          const formattedDueDate =
            invoiceData.duedate.length > 9
              ? invoiceData.duedate
              : invoiceData.duedate.replace("Z", "T000000Z");
          payload.duedate = formattedDueDate;
          this.props.dispatch(updateInvoice(invoiceData.key, payload));
        }
      }
    }

    if (updateInvoiceAfterPayment && !haveDownloadDataAfterCashOrGiftPayment) {
      this.updateThisStep({ haveDownloadDataAfterCashOrGiftPayment: true });
      if (invoiceKey) {
        this.props.dispatch(getInvoice(invoiceKey));
      }
      this.props.dispatch(getBookingPayments(currentBookingId));
    }

    if (invoicePdfData && printInvoicePdf) {
      this.updateThisStep({ printInvoicePdf: false });
      this.showInvoicePdfFile(invoicePdfData);
    }
  }

  componentWillMount() {
    let { currentBookingId, posSettings } = this.props;
    this.props.dispatch(getGiftCertSetting());
    this.props.dispatch(getPosSettings());
    window.Stripe(window.APP.stripeKey); //configure stripe
    if (currentBookingId) {
      this.props.dispatch(getBookingPayments(currentBookingId));
    }
  }

  componentDidMount() {
    const {
      appointmentStepData: {
        selectedCustomer,
        paymentsEnabled,
        multiServiceList,
      },
      appointmentStepData,
      currentBookingId,
      invoiceData,
    } = this.props;

    this.getPaymentSettingData();

    const customerName =
      (selectedCustomer.firstname || "") +
      " " +
      (selectedCustomer.lastname || "");
    this.updateThisStep({
      nameOnCard: customerName,
      shareInvoiceEmail: selectedCustomer.email,
      didDoRefund: false,
    });
    const { bookingRevenue } = this.props.checkoutAppointmentStepData;

    document.body.addEventListener(
      "click",
      this.state.handleClickOutsideDiscountMenu
    );

    let { price, name } = multiServiceList[0].selectedService;

    let serviceName = "";
    let servicePrice = "";
    if (paymentsEnabled) {
      if (invoiceData && invoiceData.key && invoiceData.items) {
        const bookingItem = invoiceData.items.find((invoiceItem) => {
          let invoiceBooking = 0;
          if (invoiceItem.reference) {
            invoiceBooking = parseInt(invoiceItem.reference, 10);
          }

          return invoiceItem.reference == currentBookingId;
        });
        serviceName = bookingItem.description;
        servicePrice = bookingItem.amount;
      }
    } else {
      serviceName = name;
      servicePrice = price;
    }

    if (this.canCheckoutCurrentBooking() && this.canEditCurrentBooking()) {
      this.props.dispatch(
        getBookingPayments(currentBookingId, () => {
          setTimeout(() => {
            const {
              posSettings,
              creatingInvoice,
              updatingInvoice,
            } = this.props;
            if (!creatingInvoice && !updatingInvoice) {
              confirmServicePriceChangeAndGenerateInvoice(
                price,
                name,
                0,
                multiServiceList[0],
                currentBookingId,
                this.props.invoiceData,
                appointmentStepData,
                this.updateAppointmentStep,
                bookingRevenue,
                posSettings,
                this.props.dispatch
              );
            }
          }, 0); //execute after payment data has been obtained
        })
      );
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener(
      "click",
      this.state.handleClickOutsideDiscountMenu
    );
  }

  getPaymentSettingData = () => {
    this.props.dispatch(getPaymentSetting());
  };

  dispatchUpdateAppointmentStepData = (appointmentStepData) => {
    this.props.dispatch(updateAppointmentStepData(appointmentStepData));
  };

  updateAppointmentStep = (data, multiItemIndex) => {
    let { multiServiceList } = this.props.appointmentStepData;
    let newData = "";
    newData = clone(this.props.appointmentStepData);
    if (multiItemIndex != undefined) {
      newData.multiServiceList[multiItemIndex] = objectAssign(
        {},
        multiServiceList[multiItemIndex],
        data
      );
    } else {
      newData = objectAssign({}, this.props.appointmentStepData, data);
    }
    this.dispatchUpdateAppointmentStepData(newData);
  };

  updateServicePriceHandler = (event, multiItemIndex, multiServiceItem) => {
    let { Currency } = window.APP.LANGUAGE;
    const cleanedPrice = event.target.value.replace(Currency, "");

    let value = event.target.value;
    value = value.replace(window.APP.LANGUAGE.Currency, "");
    value = value.replace(/[^0-9.:]/g, "");

    if (value.includes(".")) {
      value = value.split(".")[0] + "." + value.split(".")[1].substring(0, 2);
    }

    if (value == undefined) value = 0.0;

    let copy = clone(multiServiceItem.selectedService);
    copy.price = value;

    if (Number(value) < maxPrice) {
      this.updateAppointmentStep({ selectedService: copy }, multiItemIndex);
    }
  };

  updateInvoiceItemPriceHandler = (event, invoiceItem) => {
    let { Currency } = window.APP.LANGUAGE;
    const cleanedPrice = event.target.value.replace(Currency, "");

    let value = event.target.value;
    value = value.replace(window.APP.LANGUAGE.Currency, "");
    value = value.replace(/[^0-9.:]/g, "");

    if (value.includes(".")) {
      value = value.split(".")[0] + "." + value.split(".")[1].substring(0, 2);
    }

    if (value == undefined) value = 0.0;

    let copy = clone(invoiceItem);
    copy.amount = value;

    if (Number(value) < maxPrice) {
      this.updateThisStep({ editedInvoiceItemPrice: copy });
    }
  };

  updateGiftCertSaleFormVisibility = (isVisible) => {
    this.props.dispatch(updateGiftCertSaleFormVisibility(isVisible));
  };

  canCheckoutCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canCheckoutAllBookings ||
      limitedPermissions.bookingsCheckoutableByCurrentUser.indexOf(
        currentBookingId
      ) > -1
    );
  };

  canEditCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canEditAllBookings ||
      (limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) > -1 &&
        currentBookingId)
    );
  };

  getGiftCertValueForKey = (giftCertKey) => {
    this.props.dispatch(addNewGiftCertKeyToValueList(giftCertKey));
    this.props.dispatch(getGiftCertWithKey(giftCertKey));
  };

  getServicesRowsWithServiceClass = (multiServiceItem, multiItemIndex) => {
    let { Currency } = window.APP.LANGUAGE;
    let {
      appointmentStepData: { paymentStatus, multiServiceList },
      currentBookingId,
      invoiceData,
      appointmentStepData,
      posSettings,
    } = this.props;
    const { bookingRevenue } = this.props.checkoutAppointmentStepData;

    let { name, price } = multiServiceItem.selectedService;

    let disabled =
      !this.canCheckoutCurrentBooking() ||
      !this.canEditCurrentBooking() ||
      paymentStatus == paymentStatusEnum.STATUS_PAID;

    let getPriceDisplay = () => {
      return (
        <div
          key={`multi-item-row${multiItemIndex}`}
          className={`checkout_price_controls ${
            disabled ? "disabled-row" : ""
          }`}
        >
          <Txt
            className="checkout_price_input"
            onKeyDown={(e) => {
              if (e.keyCode == 13) {
                confirmServicePriceChangeAndGenerateInvoice(
                  price,
                  null,
                  multiItemIndex,
                  multiServiceItem,
                  currentBookingId,
                  invoiceData,
                  appointmentStepData,
                  this.updateAppointmentStep,
                  bookingRevenue,
                  posSettings,
                  this.props.dispatch
                );
                e.target.blur();
              }
            }}
            onChange={(e) =>
              this.updateServicePriceHandler(
                e,
                multiItemIndex,
                multiServiceItem
              )
            }
            type="input"
            value={Currency + price}
            onBlur={(e) =>
              confirmServicePriceChangeAndGenerateInvoice(
                price,
                null,
                multiItemIndex,
                multiServiceItem,
                currentBookingId,
                invoiceData,
                appointmentStepData,
                this.updateAppointmentStep,
                bookingRevenue,
                posSettings,
                this.props.dispatch
              )
            }
          ></Txt>
        </div>
      );
    };

    return (
      <div key={`priceservicelist${multiItemIndex}`} className="services">
        <div className="service_row">
          <div className=" service_name">{name}</div>
          {getPriceDisplay()}
        </div>
      </div>
    );
  };

  getEditableInvoiceItemRows = () => {
    const {
      GiftCertInvoiceItemText,
      AddGiftCertToCheckout,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let { Currency } = window.APP.LANGUAGE;
    let {
      appointmentStepData: { paymentStatus, multiServiceList },
      currentBookingId,
      invoiceData,
      appointmentStepData,
      posSettings,
      giftCertSetting,
      giftCertValueList,
      creatingGiftCertificate,
    } = this.props;
    let disabled =
      !this.canCheckoutCurrentBooking() ||
      !this.canEditCurrentBooking() ||
      paymentStatus == paymentStatusEnum.STATUS_PAID;
    let { editedInvoiceItemPrice } = this.props.checkoutAppointmentStepData;

    if (invoiceData.items) {
      let productItemsObject = invoiceData.items.filter((invoiceItem) => {
        return invoiceItem.type == "PRODUCT";
      });
      let giftCertItemsObject = invoiceData.items.filter((invoiceItem) => {
        return invoiceItem.type == "GIFTCERT";
      });

      let getAddGiftCertButton = () => {
        if (giftCertSetting && giftCertSetting.giftcertenabled) {
          return (
            <div
              className="add_giftcert_button"
              onClick={this.updateGiftCertSaleFormVisibility.bind(this, true)}
            >
              {AddGiftCertToCheckout}
            </div>
          );
        } else {
          return "";
        }
      };

      return (
        <div>
          <div className="checkout_item_rows">
            {productItemsObject.map((invoiceItem, i) => {
              let price = decimalPoint(invoiceItem.amount);
              if (
                editedInvoiceItemPrice.type == invoiceItem.type &&
                editedInvoiceItemPrice.reference == invoiceItem.reference
              ) {
                price = editedInvoiceItemPrice.amount;
              }

              let getPriceDisplay = () => {
                return (
                  <div
                    key={`invoice-${i}`}
                    className={`checkout_price_controls ${
                      disabled ? "disabled-row" : ""
                    }`}
                  >
                    <div className="checkout_item_count">
                      {invoiceItem.count} x{" "}
                    </div>
                    <Txt
                      className="checkout_price_input product_input"
                      type="input"
                      onChange={(e) =>
                        this.updateInvoiceItemPriceHandler(e, invoiceItem)
                      }
                      value={Currency + price}
                      onKeyDown={(e) => {
                        if (e.keyCode == 13) {
                          e.target.blur();
                        }
                      }}
                      onBlur={this.confirmEditedInvoiceItemPrice}
                    ></Txt>
                    <i
                      onClick={this.handleRemovingInvoiceItemFromInvoice.bind(
                        this,
                        invoiceItem
                      )}
                      className="trash-icon"
                    ></i>
                  </div>
                );
              };

              return (
                <div className="checkout_item_row">
                  <div className="invoice_item_name">
                    {invoiceItem.description}
                  </div>
                  {getPriceDisplay()}
                </div>
              );
            })}

            {giftCertItemsObject.map((invoiceItem, i) => {
              let giftCertValueObj = giftCertValueList.find((gifCert) => {
                return gifCert.key == invoiceItem.reference;
              });
              let valueString = "";
              if (giftCertValueObj) {
                if (giftCertValueObj.value) {
                  valueString =
                    "(" +
                    Currency +
                    decimalPoint(giftCertValueObj.value) +
                    " value)";
                }
              } else {
                this.getGiftCertValueForKey(invoiceItem.reference);
              }

              let price = decimalPoint(invoiceItem.amount);
              if (
                editedInvoiceItemPrice.type == invoiceItem.type &&
                editedInvoiceItemPrice.reference == invoiceItem.reference
              ) {
                price = editedInvoiceItemPrice.amount;
              }

              let getPriceDisplay = () => {
                return (
                  <div
                    key={`invoice-${i}`}
                    className={`checkout_price_controls ${
                      disabled ? "disabled-row" : ""
                    }`}
                  >
                    <Txt
                      className="checkout_price_input giftcert_input"
                      type="input"
                      onChange={(e) =>
                        this.updateInvoiceItemPriceHandler(e, invoiceItem)
                      }
                      value={Currency + price}
                      onKeyDown={(e) => {
                        if (e.keyCode == 13) {
                          e.target.blur();
                        }
                      }}
                      onBlur={this.confirmEditedInvoiceItemPrice}
                    ></Txt>
                    <i
                      onClick={this.handleRemovingInvoiceItemFromInvoice.bind(
                        this,
                        invoiceItem
                      )}
                      className="trash-icon"
                    ></i>
                  </div>
                );
              };

              return (
                <div className="checkout_item_row">
                  <div className="invoice_item_name">
                    <span className="font_600">{GiftCertInvoiceItemText}</span>{" "}
                    {valueString}
                  </div>
                  {getPriceDisplay()}
                </div>
              );
            })}
          </div>
          {getAddGiftCertButton()}
        </div>
      );
    }
  };

  getNonEditableInvoiceItemsRow = (serviceName, servicePrice) => {
    let { Currency } = window.APP.LANGUAGE;
    const {
      GiftCertInvoiceItemText,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let { invoiceData, giftCertValueList } = this.props;

    if (invoiceData.items) {
      let productItemsObject = invoiceData.items.filter((invoiceItem) => {
        return invoiceItem.type == "PRODUCT";
      });
      let giftCertItemsObject = invoiceData.items.filter((invoiceItem) => {
        return invoiceItem.type == "GIFTCERT";
      });

      return (
        <div className="items_row">
          <div className="item_row">
            <div className="invoice_items">{serviceName}</div>
            <div className="items_cost">
              {Currency}
              {decimalPoint(servicePrice)}
            </div>
          </div>
          {productItemsObject.map((invoiceItem) => {
            return (
              <div className="item_row">
                <div className="invoice_items">{invoiceItem.name}</div>
                <div className="items_quantity">{invoiceItem.count}</div>
                <div className="items_cost">
                  {Currency}
                  {decimalPoint(invoiceItem.amount)}
                </div>
              </div>
            );
          })}
          {giftCertItemsObject.map((invoiceItem) => {
            let giftCertValueObj = giftCertValueList.find((gifCert) => {
              return gifCert.key == invoiceItem.reference;
            });
            let valueString = "";
            if (giftCertValueObj) {
              if (giftCertValueObj.value) {
                valueString =
                  "(" +
                  Currency +
                  decimalPoint(giftCertValueObj.value) +
                  " value)";
              }
            } else {
              this.getGiftCertValueForKey(invoiceItem.reference);
            }

            return (
              <div className="item_row">
                <div className="invoice_items">
                  {GiftCertInvoiceItemText + " " + valueString}
                </div>
                <div className="items_cost">
                  {Currency}
                  {decimalPoint(invoiceItem.amount)}
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  };

  getDateAndInvoice = () => {
    if (this.props.invoiceData.key) {
      const {
        InvoiceNumberTitle,
      } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
      const { duedate, invoicenumber } = this.props.invoiceData;
      const formattedDueDate =
        duedate.length > 9 ? duedate : duedate.replace("Z", "T000000Z");
      const invoiceDueDate = timezoneMoment.utc(formattedDueDate);
      return (
        <div className="invoice">
          <span className="font_600">
            {invoiceDueDate
              .tz(this.props.appointmentStepData.timezone)
              .format("MMM DD, YYYY")}
          </span>
          <span className="invoice_number">
            {InvoiceNumberTitle}
            <span className="font_600">{invoicenumber}</span>{" "}
          </span>
        </div>
      );
    }
  };

  getPaymentUrl() {
    let paymentUrl =
      window.APP.apiPath +
      "/serviceprovider/" +
      window.SERVICE_PROVIDER_ID +
      "/settings/payments";

    return paymentUrl;
  }

  updateDiscountDropdownVisibility = (isVisible) => {
    this.props.dispatch(updateDiscountDropdownVisibility(isVisible));
  };

  updateSelectedDiscount = (discountItem) => {
    const { currentBookingId, invoiceData } = this.props;
    const formattedDueDate =
      invoiceData.duedate.length > 9
        ? invoiceData.duedate
        : invoiceData.duedate.replace("Z", "T000000Z");
    let payload = {
      customerid: invoiceData.customerid,
      duedate: formattedDueDate,
      items: [],
    };

    invoiceData.items.map((invoiceItem) => {
      if (invoiceItem.type != "DISCOUNT") {
        let payloadItem = createPayloadItemFromInvoiceItem(invoiceItem);
        payload.items.push(payloadItem);
      }
    });
    if (discountItem) {
      let discountPayload = {
        type: "DISCOUNT",
        count: 1,
        description: discountItem.name,
        reference: discountItem.reference,
        amount: discountItem.amount,
        amounttype: discountItem.amounttype,
      };
      payload.items.push(discountPayload);
    }
    this.props.dispatch(updateInvoice(invoiceData.key, payload));
    this.updateDiscountDropdownVisibility(false);
  };

  confirmEditedInvoiceItemPrice = () => {
    let { InvoiceCantBeOverpaid } = window.APP.LANGUAGE.Errors;
    const { currentBookingId, invoiceData } = this.props;
    const { editedInvoiceItemPrice } = this.props.checkoutAppointmentStepData;
    const formattedDueDate =
      invoiceData.duedate.length > 9
        ? invoiceData.duedate
        : invoiceData.duedate.replace("Z", "T000000Z");

    if (editedInvoiceItemPrice.reference.length > 0) {
      let payload = {
        customerid: invoiceData.customerid,
        duedate: formattedDueDate,
        items: [],
      };
      invoiceData.items.map((invoiceItem) => {
        if (
          invoiceItem.type == editedInvoiceItemPrice.type &&
          invoiceItem.reference == editedInvoiceItemPrice.reference
        ) {
          let payloadItem = createPayloadItemFromInvoiceItem(
            editedInvoiceItemPrice
          );
          payload.items.push(payloadItem);
        } else {
          let payloadItem = createPayloadItemFromInvoiceItem(invoiceItem);
          payload.items.push(payloadItem);
        }
      });
      let cb = () => {
        this.updateThisStep({ editedInvoiceItemPrice: {} });
      };
      this.props.dispatch(updateInvoice(invoiceData.key, payload, cb));
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(InvoiceCantBeOverpaid)
      );
    }
  };

  handleRemovingInvoiceItemFromInvoice = (invoiceItem) => {
    let { InvoiceCantBeOverpaid } = window.APP.LANGUAGE.Errors;
    const { currentBookingId, invoiceData } = this.props;
    const { editedInvoiceItemPrice } = this.props.checkoutAppointmentStepData;
    const formattedDueDate =
      invoiceData.duedate.length > 9
        ? invoiceData.duedate
        : invoiceData.duedate.replace("Z", "T000000Z");

    let payload = {
      customerid: invoiceData.customerid,
      duedate: formattedDueDate,
      items: [],
    };
    invoiceData.items.map((item) => {
      if (invoiceItem != item) {
        let payloadItem = createPayloadItemFromInvoiceItem(item);
        payload.items.push(payloadItem);
      }
    });
    let cb = () => {
      this.updateThisStep({ editedInvoiceItemPrice: {} });
    };
    this.props.dispatch(updateInvoice(invoiceData.key, payload, cb));
    this.props.dispatch(
      removeGlobalErrorMessageIfMatchesThisString(InvoiceCantBeOverpaid)
    );
  };

  getTotalCostOfServicesSummary = () => {
    let {
      discountMenuVisible,
      posSettings,
      invoiceData,
      appointmentStepData: { paymentsEnabled, paymentStatus },
    } = this.props;
    let { selectedDiscountPercentage } = this.props.checkoutAppointmentStepData;
    let {
      selectedService,
    } = this.props.appointmentStepData.multiServiceList[0];
    let {
      SubtotalTitle,
      TaxTitle,
      TotalCostTitle,
      DiscountTitle,
      AddTitle,
      DiscountOptionNone,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let { Currency } = window.APP.LANGUAGE;

    let disabled =
      !this.canCheckoutCurrentBooking() ||
      !this.canEditCurrentBooking() ||
      paymentStatus == paymentStatusEnum.STATUS_PAID;

    if (invoiceData.key) {
      let getDiscountButton = () => {
        if (!posSettings || !posSettings.discounts) {
          return "";
        }
        const activeDiscount = posSettings.discounts.find((discount) => {
          return discount.active;
        });

        let discountButtonText = AddTitle;
        if (invoiceData.discountamount > 0) {
          discountButtonText =
            Currency + decimalPoint(invoiceData.discountamount);
        }

        if (!disabled && activeDiscount) {
          return (
            <span
              className="add_discount"
              onClick={this.updateDiscountDropdownVisibility.bind(this, true)}
            >
              {discountButtonText}
            </span>
          );
        } else {
          return (
            <span className="add_discount disabled">{discountButtonText}</span>
          );
        }
      };

      let getDiscountDropdown = () => {
        if (posSettings) {
          return (
            <ul>
              <li
                className=""
                role="option"
                onClick={this.updateSelectedDiscount.bind(this, null)}
              >
                {DiscountOptionNone}
              </li>
              {posSettings.discounts.map((item) => {
                if (item.active) {
                  return (
                    <li
                      key={item.name}
                      role="option"
                      onClick={this.updateSelectedDiscount.bind(this, item)}
                    >
                      {item.name} - {item.amount}%
                    </li>
                  );
                }
              })}
            </ul>
          );
        }
      };

      let getTaxAmountText = () => {
        return (
          <span className="tax_price disabled">
            {Currency}
            {decimalPoint(invoiceData.taxamount)}
          </span>
        );
      };

      return (
        <div className="total_section">
          <div className="total_title">
            {SubtotalTitle}
            <span className="subtotal_price">
              {Currency}
              {decimalPoint(invoiceData.subtotalamount)}
            </span>
          </div>
          <div className="total_title">
            {TaxTitle}
            <div className="add_tax_list">{getTaxAmountText()}</div>
          </div>
          <div className="total_title no_bottom_border">
            <span
              className={`${
                selectedDiscountPercentage !== "" ? "" : "booking_disabled"
              }`}
            >
              {DiscountTitle}
            </span>
            <div className="add_discount_list">
              {getDiscountButton()}
              <div
                role="listbox"
                key="qwe123"
                className={`basic_dropdown_list discount_select ${
                  discountMenuVisible ? "" : "hidden"
                }`}
              >
                {getDiscountDropdown()}
              </div>
            </div>
          </div>
          <div className="total_cost_box">
            <div
              className={`total_title no_bottom_border ${
                paymentsEnabled ? "" : "booking_disabled"
              }`}
            >
              {TotalCostTitle}:{" "}
              <span className="total_price">
                {Currency}
                {decimalPoint(invoiceData.totalamount)}
              </span>{" "}
            </div>
          </div>
        </div>
      );
    }
  };

  getSummaryView = () => {
    let {
      selectedService,
    } = this.props.appointmentStepData.multiServiceList[0];
    let {
      appointmentStepData: { paymentsEnabled, multiServiceList },
      checkoutMode,
      invoiceData,
      currentBookingId,
    } = this.props;
    let {
      SubtotalTitle,
      TaxTitle,
      TotalCostTitle,
      DiscountTitle,
      PaymentsMustBeEnabledPartOne,
      PaymentsMustBeEnabledPartTwo,
      PaymentsMustBeEnabledPartZero,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let { Currency } = window.APP.LANGUAGE;

    if (checkoutMode != checkoutModesEnum.VIEW_MODE) {
      return "";
    }

    return (
      <div>
        {paymentsEnabled ? (
          <div>
            <div className="top-section service_price_section">
              {/* {multiServiceList.map((multiServiceItem,multiItemIndex) =>{
                  return this.getServicesRowsWithServiceClass(multiServiceItem,multiItemIndex)
              })} Fix for DES-716 to show only current booking in payment summary*/}
              {this.getServicesRowsWithServiceClass(multiServiceList[0], 0)}
              {this.getEditableInvoiceItemRows()}
            </div>
            <div className="bottom-section">
              <div className="left-info">{this.getDateAndInvoice()}</div>
              <div className="right-info">
                {this.getTotalCostOfServicesSummary()}
              </div>
            </div>
          </div>
        ) : (
          <div className="payment_disabled">
            <div className="checkout_block"></div>
            <span className="font_600">
              {PaymentsMustBeEnabledPartZero}
            </span>{" "}
            {PaymentsMustBeEnabledPartOne}&nbsp;
            <a target="_blank" href={this.getPaymentUrl()}>
              {PaymentsMustBeEnabledPartTwo}.
            </a>{" "}
          </div>
        )}
      </div>
    );
  };

  getCreditCardPaymentCard = () => {
    const { bookingPaymentsData } = this.props;
    if (bookingPaymentsData && bookingPaymentsData.payments) {
      const offlineCardPayment = bookingPaymentsData.payments.find(
        (payment) => {
          return payment.card.cardpresent === false;
        }
      );
      if (offlineCardPayment) {
        return offlineCardPayment.card;
      }
    }
  };

  changePaymentAmountWithinConstraints = (ev) => {
    let { InvoiceCantBeOverpaid } = window.APP.LANGUAGE.Errors;
    const { outstandingamount } = this.props.invoiceData;
    let paymentAmount = ev.target.value.replace("$", "");

    if (
      (/[0-9]+\.?([0-9]{0,2})?$/.test(paymentAmount) &&
        Number(paymentAmount) <= outstandingamount) ||
      paymentAmount.length == 0
    ) {
      const decimalPlace = paymentAmount.split(".")[1];
      if (decimalPlace && decimalPlace.length > 2) {
        return;
      }
      this.updateThisStep({ paymentAmount: paymentAmount });
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(InvoiceCantBeOverpaid)
      );
    }
  };

  dispatchUpdatePaymentMode = (mode) => {
    this.props.dispatch(updatePaymentMode(mode));
  };

  requestRefundForPayment = (paymentId) => {
    this.updateThisStep({
      refundConfirmationVisible: true,
      refundPaymentId: paymentId,
    });
  };

  toggleShowShareInvoiceBox = (showShareInvoiceBox) => {
    this.props.dispatch(updateShareInvoiceVisibility(true));
  };

  getInvoicePdf = () => {
    this.props.dispatch(
      getInvoicePdf(this.props.checkoutAppointmentStepData.invoiceKey)
    );
    this.updateThisStep({ printInvoicePdf: true });
  };

  showInvoicePdfFile = (blob) => {
    if (window.navigator.msSaveOrOpenBlob) {
      var blobObject = new Blob([blob]);
      window.navigator.msSaveOrOpenBlob(blobObject, "invoice.pdf");
    } else {
      let pdfWindow = window.open(URL.createObjectURL(blob));
      if (pdfWindow) {
        pdfWindow.print();
      }
    }
  };

  formatPaymentField = () => {
    let { paymentAmount } = this.props.checkoutAppointmentStepData;
    this.updateThisStep({ paymentAmount: decimalPoint(paymentAmount) });
  };

  canCheckoutCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canCheckoutAllBookings ||
      limitedPermissions.bookingsCheckoutableByCurrentUser.indexOf(
        currentBookingId
      ) > -1
    );
  };

  getPaymentDetailsView = () => {
    //TODO refactor this into its own component
    let {
      InvoiceItemsTitle,
      PaymentSubTitle,
      PaymentAmountTotalPlaceholder,
      PaymentTitle,
      InvoiceNumberTitle,
      StoreCardForLaterTitle,
      PriceTitle,
      CardNumberPlaceholder,
      MonthYearPlaceholder,
      NameOnCardPlaceholder,
      CvvPlaceHolder,
      IncludedTipButton,
      ShareInvoiceTitle,
      CreditCardTitle,
      CashTitle,
      GiftCertTitle,
      EmailLinkText,
      PrintLinkText,
      PaymentsReceivedTitle,
      PaymentRequestRefundTitle,
      PaymentRefundTitle,
      PaymentRefundedTitle,
      PaymentCashTitle,
      PaymentAmountPlaceholder,
      TipTotalCostTitle,
      PaymentsMustBeEnabledPartZero,
      PaymentsMustBeEnabledPartOne,
      PaymentsMustBeEnabledPartTwo,
      TotalCostTitle,
      TotalTitle,
      OutstandingTitle,
      PaidInFullText,
      PaymentGiftCertTitle,
      PaymentNoRefundTitle,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let { Currency } = window.APP.LANGUAGE;
    let {
      PaymentAmountMissing,
      NameOnCardMissing,
      CreditCardNameRequired,
      InvoiceCantBeOverpaid,
    } = window.APP.LANGUAGE.Errors;
    let {
      checkoutMode,
      invoiceData,
      bookingPaymentsData,
      paymentMode,
      currentBookingId,
    } = this.props;
    let serviceName = "";
    let servicePrice = "";

    let disabled = !this.canCheckoutCurrentBooking();

    if (invoiceData.key) {
      const bookingItem = invoiceData.items.find((invoiceItem) => {
        return invoiceItem.reference == currentBookingId;
      });
      serviceName = bookingItem.description;
      servicePrice = bookingItem.amount;
    }

    let {
      paymentAmount,
      customTipAmount,
    } = this.props.checkoutAppointmentStepData;
    if (checkoutMode != checkoutModesEnum.PAYMENT_MODE) {
      return "";
    }

    let getCashPaymentForm = () => {
      let { posSettings } = this.props;
      if (paymentMode != paymentModeEnum.CASH_MODE) return "";
      else {
        const disablePayment = invoiceData.status == "PAID";
        return (
          <div>
            <div className="cash_area ">
              <div className="cash_icon"></div>
            </div>
            <div className="payment_footer">
              <div className="tipLabel">
                <div>
                  <label className="tipLabel_title">{PaymentSubTitle}</label>
                </div>
                &nbsp;
                {posSettings &&
                posSettings.tipssettings &&
                posSettings.tipssettings.enabled ? (
                  <a
                    className={`tip_link ${
                      disabled || disablePayment ? " disabled-insensitive" : ""
                    }`}
                    onClick={this.handleChangeTipPopupVisibility.bind(
                      this,
                      true
                    )}
                  >
                    {IncludedTipButton}
                  </a>
                ) : (
                  ""
                )}
              </div>
              <div className="totalLabel">
                <ValidMe
                  validmemessage={PaymentAmountMissing}
                  fieldclasses="mrnull"
                  validmefor="required"
                  group="thirdStepCheckoutAppointment"
                >
                  <Txt
                    type="input"
                    fieldclasses="mrnull"
                    onBlur={this.formatPaymentField}
                    className="payment_amount active"
                    disabled={disablePayment}
                    onChange={this.changePaymentAmountWithinConstraints}
                    placeholder={PaymentAmountPlaceholder}
                    value={paymentAmount > 0 ? "$" + paymentAmount : ""}
                  ></Txt>
                </ValidMe>
              </div>
            </div>
          </div>
        );
      }
    };

    let getPaymentInvoiceDetails = () => {
      const { invoiceKey } = this.props.checkoutAppointmentStepData;
      const pdfUrl =
        window.APP.apiPath +
        "api/serviceprovider/" +
        window.SERVICE_PROVIDER_ID +
        "/invoices/" +
        invoiceKey +
        "/pdf";
      let { duedate, invoicenumber } = this.props.invoiceData;
      const formattedDueDate =
        duedate.length > 9 ? duedate : duedate.replace("Z", "T000000Z");
      const invoiceDueDate = timezoneMoment.utc(formattedDueDate);

      return (
        <div className="invoice payment_invoice">
          <span className="font_600">
            {invoiceDueDate
              .tz(this.props.appointmentStepData.timezone)
              .format("MMM DD, YYYY")}
          </span>
          <span className="invoice_number">
            {InvoiceNumberTitle}
            <span className="font_600">
              {(invoiceData || {}).invoicenumber}
            </span>
          </span>
          <div className="share_invoice">
            <span>{ShareInvoiceTitle}:</span>
            <div className="share_links">
              <a onClick={() => this.toggleShowShareInvoiceBox(true)}>
                {EmailLinkText}
              </a>
              <a onClick={this.getInvoicePdf} className="share_invoice_print">
                {PrintLinkText}
              </a>
            </div>
          </div>
        </div>
      );
    };

    let getPaymentsList = () => {
      if (bookingPaymentsData) {
        let paymentsListObject = [];
        if (bookingPaymentsData.payments) {
          const filteredCardPayment = bookingPaymentsData.payments.filter(
            (payment) => {
              return payment.transactiontype;
            }
          );
          paymentsListObject = paymentsListObject.concat(filteredCardPayment);
        }
        if (bookingPaymentsData.cashpayments) {
          paymentsListObject = paymentsListObject.concat(
            bookingPaymentsData.cashpayments
          );
        }
        if (bookingPaymentsData.giftcertpayments) {
          paymentsListObject = paymentsListObject.concat(
            bookingPaymentsData.giftcertpayments
          );
        }
        paymentsListObject.sort(function (payment1, payment2) {
          if (payment1.date < payment2.date) {
            return 1;
          }
          if (payment1.date > payment2.date) {
            return -1;
          }
          return 0;
        });
        const refundOnlyPaymentArray = paymentsListObject.filter((payment) => {
          return payment.reference;
        });
        return (
          <div className="payments_received_rows">
            {paymentsListObject.map((payment, i) => {
              const paymentDate = timezoneMoment
                .utc(payment.date)
                .tz(this.props.appointmentStepData.timezone)
                .format("MMM DD YYYY, H:mma");
              let paymentString = Currency + payment.paid;
              if (payment.card) {
                const refundOrPayment = () => {
                  if (payment.transactiontype.id == 7) {
                    paymentString = "-" + paymentString;
                    return (
                      <div
                        key={`${i}payment-refund`}
                        className="payment_refunded"
                      >
                        {PaymentRefundTitle}
                      </div>
                    );
                  } else {
                    const foundRefund = refundOnlyPaymentArray.find(
                      (refund) => {
                        return refund.reference == payment.id;
                      }
                    );
                    if (foundRefund) {
                      return (
                        <div className="payment_refunded">
                          {PaymentRefundedTitle}
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className={`payment_request_refund ${
                            disabled ? " disabled-insensitive" : ""
                          } `}
                          onClick={() =>
                            this.requestRefundForPayment(payment.id)
                          }
                        >
                          {PaymentRequestRefundTitle}
                        </div>
                      );
                    }
                  }
                };
                return (
                  <div
                    key={`${payment.id}payment-item`}
                    className="payment_history"
                  >
                    <div className="payment_method">
                      <div
                        className={"icon _" + payment.card.type.toLowerCase()}
                      />
                      {"x" + payment.card.last4}
                    </div>
                    <div className="payment_date_time">{paymentDate}</div>
                    {refundOrPayment()}
                    <div className="payments_received">{paymentString}</div>
                  </div>
                );
              } else {
                if (bookingPaymentsData.cashpayments.indexOf(payment) == -1) {
                  // Gift Cert payment
                  return (
                    <div className="payment_history">
                      <div className="payment_method">
                        {PaymentGiftCertTitle}
                      </div>
                      <div className="payment_date_time">{paymentDate}</div>
                      <div className="payment_request_refund disabled-insensitive">
                        {PaymentNoRefundTitle}
                      </div>
                      <div className="payments_received">{paymentString}</div>
                    </div>
                  );
                } else {
                  // Cash payment
                  const refundOrPayment = () => {
                    if (payment.type == "REFUND") {
                      paymentString = "-" + paymentString;
                      return (
                        <div className="payment_refunded">
                          {PaymentRefundTitle}
                        </div>
                      );
                    } else {
                      const foundRefund = refundOnlyPaymentArray.find(
                        (refund) => {
                          return refund.reference == payment.ledgerentrykey;
                        }
                      );
                      if (foundRefund) {
                        return (
                          <div className="payment_refunded">
                            {PaymentRefundedTitle}
                          </div>
                        );
                      } else {
                        return (
                          <div
                            className={`payment_request_refund ${
                              disabled ? " disabled-insensitive" : ""
                            } `}
                            onClick={() =>
                              this.requestRefundForPayment(
                                payment.ledgerentrykey
                              )
                            }
                          >
                            {PaymentRequestRefundTitle}
                          </div>
                        );
                      }
                    }
                  };
                  return (
                    <div className="payment_history">
                      <div className="payment_method">{PaymentCashTitle}</div>
                      <div className="payment_date_time">{paymentDate}</div>
                      {refundOrPayment()}
                      <div className="payments_received">{paymentString}</div>
                    </div>
                  );
                }
              }
            })}
          </div>
        );
      }
    };

    const getOutstandingOrPaid = () => {
      if (invoiceData.status == "PAID") {
        return (
          <div className="payment_paidFull">
            {PaidInFullText}:{" "}
            <span className="total_price">
              {Currency}
              {decimalPoint(invoiceData.balanceamount)}
            </span>{" "}
          </div>
        );
      } else {
        return (
          <div className="payment_outstanding">
            {OutstandingTitle}:{" "}
            <span className="total_price">
              {Currency}
              {decimalPoint(invoiceData.outstandingamount)}
            </span>{" "}
          </div>
        );
      }
    };

    return (
      <div>
        <div className="left-section-payment payment_section">
          <div className="label-title">{PaymentTitle}</div>
          <div className={`payment_box ${disabled ? "disabled-row" : ""}`}>
            <div className="payment_header">
              <div
                onClick={this.dispatchUpdatePaymentMode.bind(
                  this,
                  paymentModeEnum.CARD_MODE
                )}
                className={`pay_tab credit_card_tab ${
                  paymentMode == paymentModeEnum.CARD_MODE ? "active" : ""
                }`}
              >
                {CreditCardTitle}
              </div>
              <div
                onClick={this.dispatchUpdatePaymentMode.bind(
                  this,
                  paymentModeEnum.CASH_MODE
                )}
                className={`pay_tab cash_tab ${
                  paymentMode == paymentModeEnum.CASH_MODE ? "active" : ""
                }`}
              >
                {CashTitle}
              </div>
              <div
                onClick={this.dispatchUpdatePaymentMode.bind(
                  this,
                  paymentModeEnum.GIFT_MODE
                )}
                className={`pay_tab giftcert_tab ${
                  paymentMode == paymentModeEnum.GIFT_MODE ? "active" : ""
                }`}
              >
                {GiftCertTitle}
              </div>
            </div>
            {paymentMode == paymentModeEnum.CARD_MODE &&
            this.props.paymentSetting ? (
              <React.Fragment>
                {this.props.paymentSetting.type === "stripe" ? (
                  <StripeProvider apiKey={window.APP.stripeKey}>
                    <Elements>
                      <CreditCardPaymentForm />
                    </Elements>
                  </StripeProvider>
                ) : (
                  <SquareForm />
                )}
              </React.Fragment>
            ) : (
              ""
            )}
            {getCashPaymentForm()}
            {paymentMode == paymentModeEnum.GIFT_MODE ? (
              <GiftCertPaymentForm />
            ) : (
              ""
            )}
          </div>
          {getPaymentInvoiceDetails()}
        </div>
        <div className="right-section-summary payments_details ">
          <div className="titles_row">
            <div className="invoice_items">
              <div className="label-title">{InvoiceItemsTitle}</div>
            </div>
            <div className="items_cost">
              <div className="label-title">{PriceTitle}</div>
            </div>
          </div>
          <div className="payments_details_list">
            {this.getNonEditableInvoiceItemsRow(serviceName, servicePrice)}
          </div>
          <hr className="hr" />
          <div className="label-title">
            <span> {PaymentsReceivedTitle} </span>
          </div>
          {getPaymentsList()}
          <div className="bottom-section">
            <div className="total_cost_box">
              <div className="total_title no_bottom_border ">
                {TotalTitle}:{" "}
                <span className="total_price">
                  {Currency}
                  {decimalPoint(invoiceData.totalamount)}
                </span>{" "}
              </div>
              <div className="total_title no_bottom_border ">
                {TipTotalCostTitle}:{" "}
                <span className="total_price">
                  {Currency}
                  {decimalPoint(invoiceData.gratuityamount)}
                </span>{" "}
              </div>
              {getOutstandingOrPaid()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  handleChangeTipPopupVisibility = (visibility) => {
    this.props.dispatch(changeTipPopupVisibility(visibility));
  };

  handleSelectTip = (amount, amounttype) => {
    const { currentBookingId, invoiceData } = this.props;
    const {
      selectedStaff,
    } = this.props.appointmentStepData.multiServiceList[0];
    const formattedDueDate =
      invoiceData.duedate.length > 9
        ? invoiceData.duedate
        : invoiceData.duedate.replace("Z", "T000000Z");
    let payload = {
      customerid: invoiceData.customerid,
      duedate: formattedDueDate,
      items: [],
    };
    invoiceData.items.map((invoiceItem) => {
      if (invoiceItem.type != "GRATUITY") {
        let payloadItem = createPayloadItemFromInvoiceItem(invoiceItem);
        payload.items.push(payloadItem);
      }
    });
    if (
      (invoiceData.outstandingamount == 0 && amount == 0) ||
      (invoiceData.totalamount == 0 && (amount == 0 || amounttype == "PERCENT"))
    ) {
      payload.status = "PAID";
    } else {
      let tipPayload = {
        type: "GRATUITY",
        reference: selectedStaff.id,
        amount: amount,
        amounttype: amounttype,
      };
      payload.items.push(tipPayload);
    }
    this.props.dispatch(updateInvoice(invoiceData.key, payload));
    this.handleChangeTipPopupVisibility(false);
  };

  dispatchUpdateCheckoutAppointmentStepData = (data) => {
    this.props.dispatch(updateCheckoutAppointmentStepData(data));
  };

  updateThisStep = (data) => {
    let newData = objectAssign(
      {},
      this.props.checkoutAppointmentStepData,
      data
    );
    this.dispatchUpdateCheckoutAppointmentStepData(newData);
  };

  handleCustomTipAmountChange = (ev, value) => {
    let { Currency } = window.APP.LANGUAGE;
    const cleanedTipAmount = (ev != undefined
      ? ev.target.value
      : value
    ).replace(Currency, "");
    if (
      (/[0-9]+\.?([0-9]{0,2})?$/.test(cleanedTipAmount) &&
        Number(cleanedTipAmount) < maxPrice) ||
      cleanedTipAmount.length == 0
    ) {
      const decimalPlace = cleanedTipAmount.split(".")[1];
      if (decimalPlace && decimalPlace.length > 2) {
        return;
      }
      this.updateThisStep({ customTipAmount: cleanedTipAmount });
    }
  };

  handleSelectedTipAmount = () => {
    let { customTipAmount } = this.props.checkoutAppointmentStepData;
    this.props.dispatch(changeTipPopupVisibility(false));
    this.handleSelectTip(Number(customTipAmount), "FIXED");
  };

  getTipPopup = () => {
    let {
      CostOfServicesProvided,
      AskCustomerQuestion,
      TenPercent,
      FifteenPercent,
      TwentyPercent,
      OtherAmmountPlaceholder,
      NoTipTitle,
      EnterOtherTipAmount,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let { Currency } = window.APP.LANGUAGE;

    let { customTipAmount } = this.props.checkoutAppointmentStepData;
    let {
      selectedService,
    } = this.props.appointmentStepData.multiServiceList[0];

    let { tipPopupVisible, posSettings, invoiceData } = this.props;

    let calculateAllServicesValue = () => {
      return selectedService.price;
    };

    if (
      !tipPopupVisible ||
      (posSettings &&
        posSettings.tipssettings &&
        !posSettings.tipssettings.enabled)
    )
      return "";

    return (
      <Modal
        className="bookingdetails-model tipping-modal transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className="tip_box">
            <button
              type="button"
              className="close-button"
              onClick={this.handleSelectTip.bind(this, 0, "PERCENT")}
            ></button>
            <div className="cost-box">
              <p className="cost_text">{CostOfServicesProvided}</p>
              <span className="dollar_sign">{Currency}</span>
              <span className="cost">
                {decimalPoint(invoiceData.totalamount)}
              </span>
            </div>
            <div className="tip-body">
              <h5 className="ask_for_tip">{AskCustomerQuestion}</h5>
              <div
                onClick={this.handleSelectTip.bind(this, 10, "PERCENT")}
                className="ui button btn-default tip_discount"
              >
                {TenPercent}
              </div>
              <div
                onClick={this.handleSelectTip.bind(this, 15, "PERCENT")}
                className="ui button btn-default tip_discount"
              >
                {FifteenPercent}
              </div>
              <div
                onClick={this.handleSelectTip.bind(this, 20, "PERCENT")}
                className="ui button btn-default tip_discount"
              >
                {TwentyPercent}
              </div>
              <div className="ui action input other_discount">
                <input
                  className="tip-amount tip_discount_input"
                  type="text"
                  value={customTipAmount ? Currency + customTipAmount : ""}
                  onChange={this.handleCustomTipAmountChange}
                  placeholder={OtherAmmountPlaceholder}
                />
                <button
                  onClick={this.handleSelectedTipAmount}
                  className={`ui icon button tip_dicount_btn ${
                    customTipAmount ? "active_discount_btn" : ""
                  }`}
                ></button>
              </div>
              <a
                className="no_tip"
                onClick={this.handleSelectTip.bind(this, 0, "PERCENT")}
              >
                {NoTipTitle}
              </a>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  getGiftCertSalePopup = () => {
    const { giftCertSaleFormVisible } = this.props;

    if (!giftCertSaleFormVisible) {
      return "";
    }

    return (
      <Modal
        className="bookingdetails-model cancel-appointment-modal transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className="giftcert-sale-form-box">
            <section className="giftcert-form-header">
              <div className="giftcert_icon"></div>
              <div
                className="giftcert-form-close"
                onClick={this.updateGiftCertSaleFormVisibility.bind(
                  this,
                  false
                )}
              ></div>
            </section>
            <GiftCertSaleForm />
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  handleShareEmailChange = (event) => {
    this.updateThisStep({ shareInvoiceEmail: event.target.value });
  };

  handleCancelShareInvoice = () => {
    this.props.dispatch(updateShareInvoiceVisibility(false));
  };

  handleSendShareInvoice = () => {
    const {
      invoiceKey,
      shareInvoiceEmail,
    } = this.props.checkoutAppointmentStepData;
    this.props.dispatch(
      sendShareInvoice(invoiceKey, { emailaddress: shareInvoiceEmail })
    );
    this.props.dispatch(updateShareInvoiceVisibility(false));
  };

  getShareInvoicePopUp = () => {
    const { shareInvoiceVisible } = this.props;
    const { shareInvoiceEmail } = this.props.checkoutAppointmentStepData;
    const {
      ShareInvoiceTitle,
      ShareInvoiceSubtitle,
      ShareInvoiceCancel,
      ShareInvoiceSend,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;

    if (!shareInvoiceVisible) {
      return "";
    } else {
      return (
        <Modal
          className="bookingdetails-model transparent-bg no-borders"
          open={true}
        >
          <Modal.Content className="modal_popup transparent-bg">
            <div className="modal_overlay"></div>
            <div className="share_invoice_box">
              <section className="header">
                <button
                  type="button"
                  className="close_button"
                  onClick={this.handleCancelShareInvoice}
                ></button>
                {ShareInvoiceTitle}
                <p className="save_text">{ShareInvoiceSubtitle}</p>
                <Txt
                  type="input"
                  className="share_email"
                  onChange={this.handleShareEmailChange}
                  value={shareInvoiceEmail}
                ></Txt>
              </section>
              <section className="send_box_buttons">
                <div
                  className="ui button cancel_btn"
                  onClick={this.handleCancelShareInvoice}
                >
                  {ShareInvoiceCancel}
                </div>
                <div
                  className="ui button send_btn"
                  onClick={this.handleSendShareInvoice}
                >
                  {ShareInvoiceSend}
                </div>
              </section>
            </div>
          </Modal.Content>
        </Modal>
      );
    }
  };

  handleCancelRefund = () => {
    this.updateThisStep({
      refundConfirmationVisible: false,
      refundPaymentId: null,
    });
  };

  handleConfirmRefund = () => {
    const { refundPaymentId } = this.props.checkoutAppointmentStepData;
    const { currentBookingId } = this.props;
    this.props.dispatch(
      refundInvoicePayment(currentBookingId, refundPaymentId)
    );
    this.updateThisStep({
      refundConfirmationVisible: false,
      refundPaymentId: null,
    });
  };

  getRefundConfirmationPopup = () => {
    const {
      refundConfirmationVisible,
    } = this.props.checkoutAppointmentStepData;
    const {
      ConfirmRefundTitle,
      ConfirmRefundSubtitle,
      ConfirmRefundConfirm,
      ConfirmRefundCancel,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;

    if (!refundConfirmationVisible) {
      return "";
    } else {
      return (
        <Modal
          className="bookingdetails-model transparent-bg no-borders"
          open={true}
        >
          <Modal.Content className="modal_popup transparent-bg">
            <div className="modal_overlay"></div>
            <div className="confirm_refund_box">
              <section className="header">
                <button
                  type="button"
                  className="close_button"
                  onClick={this.handleCancelRefund}
                ></button>
                {ConfirmRefundTitle}
                <p className="save_text">{ConfirmRefundSubtitle}</p>
              </section>
              <section className="send_box_buttons">
                <div
                  className="ui button cancel_btn"
                  onClick={this.handleCancelRefund}
                >
                  {ConfirmRefundCancel}
                </div>
                <div
                  className="ui button send_btn"
                  onClick={this.handleConfirmRefund}
                >
                  {ConfirmRefundConfirm}
                </div>
              </section>
            </div>
          </Modal.Content>
        </Modal>
      );
    }
  };

  getLoadingSpinner = () => {
    const {
      gettingInvoice,
      gettingPosSettings,
      creatingInvoice,
      updatingInvoice,
      updatingBookingToInvoice,
      updatingBookingPayments,
      isGettingStripeToken,
      gettingInvoicePdf,
      gettingGiftCertificate,
      redeemingGiftCertificate,
      creatingGiftCertificate,
    } = this.props;
    const isLoading =
      gettingInvoice ||
      gettingPosSettings ||
      creatingInvoice ||
      updatingInvoice ||
      updatingBookingToInvoice ||
      updatingBookingPayments ||
      isGettingStripeToken ||
      gettingInvoicePdf ||
      gettingGiftCertificate ||
      redeemingGiftCertificate ||
      creatingGiftCertificate;
    if (!isLoading) {
      return "";
    } else {
      return (
        <Dimmer active={isLoading}>
          <Loader />
        </Dimmer>
      );
    }
  };

  render() {
    return (
      <div className="form tabpane checkout_tab">
        {this.getLoadingSpinner()}
        {this.getShareInvoicePopUp()}
        {this.getRefundConfirmationPopup()}
        {this.getSummaryView()}
        {this.getPaymentDetailsView()}
        {this.getTipPopup()}
        {this.getGiftCertSalePopup()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentBookingId: state.bookingReducer.currentBookingId,
    stripeToken: state.bookingReducer.stripeToken,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    discountMenuVisible: state.appointmentCheckoutReducer.discountMenuVisible,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    giftCertValueList: state.appointmentCheckoutReducer.giftCertValueList,
    tipPopupVisible: state.appointmentCheckoutReducer.tipPopupVisible,
    shareInvoiceVisible: state.appointmentCheckoutReducer.shareInvoiceVisible,
    giftCertSaleFormVisible:
      state.appointmentCheckoutReducer.giftCertSaleFormVisible,
    posSettings: state.appointmentCheckoutReducer.posSettings,
    giftCertSetting: state.appointmentCheckoutReducer.giftCertSetting,
    paymentMode: state.appointmentCheckoutReducer.paymentMode,
    checkoutMode: state.appointmentCheckoutReducer.checkoutMode,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    bookingPaymentsData: state.appointmentCheckoutReducer.bookingPaymentsData,
    invoicePdfData: state.appointmentCheckoutReducer.invoicePdfData,
    creatingInvoice: state.appointmentCheckoutReducer.creatingInvoice,
    gettingInvoice: state.appointmentCheckoutReducer.gettingInvoice,
    gettingPosSettings: state.appointmentCheckoutReducer.gettingPosSettings,
    updatingInvoice: state.appointmentCheckoutReducer.updatingInvoice,
    updatingBookingToInvoice:
      state.appointmentCheckoutReducer.updatingBookingToInvoice,
    updatingBookingPayments:
      state.appointmentCheckoutReducer.updatingBookingPayments,
    isGettingStripeToken: state.appointmentCheckoutReducer.isGettingStripeToken,
    gettingInvoicePdf: state.appointmentCheckoutReducer.gettingInvoicePdf,
    gettingGiftCertificate:
      state.appointmentCheckoutReducer.gettingGiftCertificate,
    redeemingGiftCertificate:
      state.appointmentCheckoutReducer.redeemingGiftCertificate,
    creatingGiftCertificate:
      state.appointmentCheckoutReducer.creatingGiftCertificate,
    paymentSetting: state.appointmentCheckoutReducer.paymentSetting,
  };
}
